export default __webpack_public_path__ + "static/media/promineo-icon.24b19ee2.svg";